// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"_4474c4a","title":"_a6723a4","icon":"_feb08c9","iconOpen":"_71e747d"};